<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="">
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      @close="closeToast"
    />

    <div
      v-if="loader_page"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      >
    </div>

    <div
      v-if="!loader_page"
      class="w-full rounded overflow-hidden bg-white mt-4 p-4 font-poppins "
    >
      <div class="">
        <div class="flex">
          <div class="text-center text-[22px] md:text-[32px] sm:text-left font-medium">
            Redes Sociales
          </div>
        </div>

        <div class="flex flex-col sm:flex-row mt-4 sm:mt-1">
          <div class="w-full mb-10">
            <div class="flex justify-left items-left font-normal md:text-sm text-base md:mb-12">
              Apóyanos a completar los siguientes campos con tu información
            </div>
            <!-- Contenido del primer div -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 ">
              <div
                v-for="(item, index) in networks_broker"
                :key="item.id"
                class="flex mt-5"
              >
                
                <div class="w-[20%] sm:w-[15%] p-2 hidden justify-center items-center">
                  <div v-html="item.icon" />
                </div>

                <div class="w-[100%] sm:w-[100%]">
                  <p class="text-sm font-medium text-custom_gray mb-2">{{ item.name }}</p>
                  <fwb-input
                    v-model="networks_broker[index].link_broker"
                    :placeholder="getSocialNetworkConfig(item.name).placeholder"
                    size="sm"
                    @input="validateLinkWithRegex(item.link_broker, item.name)"
                    :class="{
                      'bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0': !item.error,
                      'border-red-500 h-11 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0': item.error
                    }" 
                  >
                    <template #prefix>
                    <div class="icon-wrapper">
                      <div v-html="getSocialNetworkConfig(item.name).icon"></div>
                    </div>
                  </template>
                  </fwb-input>
                  <span v-if="item.error" class="text-red-500 text-sm font-medium mt-1">
                    {{ item.error }}
                  </span>
                </div>
              </div>
            </div>


            <div class="flex mt-6 justify-center md:justify-end">
              <fwb-button
                class="bg-tuin-100 hover:bg-tuin_hover text-sm font-medium text-white focus:outline-none focus:ring-transparent"
                size="xl"
                @click="saveNetworksBroker()"
              >
                Guardar
              </fwb-button>
            </div>
          </div>
        </div>

        <div
          v-if="step < 3"
          class="flex flex-col sm:flex-row mt-4 sm:mt-10 justify-end items-end"
        >
          <fwb-button
            color="alternative"
            size="xl"
            @click="saveLater()"
          >
            Agregar más tarde
          </fwb-button>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script setup>
import { computed, ref, onMounted } from "vue";
import ToastAlert from "@/commond/ToastAlert.vue";
// LLamar a la sesion
import { useStore } from "vuex";
import axios from "axios";
import {
  FwbInput,
  FwbButton,
 // FwbBreadcrumb,
 // FwbBreadcrumbItem,
  //FwbHeading,
} from "flowbite-vue";
// import { useRouter } from "vue-router";
// let router = useRouter();

let networks_broker = ref([]);
let networks_company = ref([]);
let loader_page = ref(false);

let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

const store = useStore();
let session = computed(() => store.getters.getUserSession);
let step = ref(0);
//let facebook = ref('');

// Mapeo dinámico de redes sociales por nombre
const socialNetworksConfig = {
  'Facebook': {
    placeholder: "https://www.facebook.com/user",
    regex: /^https?:\/\/(www\.)?facebook\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M4.59839 11.25H6.59839V7.245H8.40039L8.59839 5.255H6.59839V4.25C6.59839 4.11739 6.65107 3.99021 6.74484 3.89645C6.83861 3.80268 6.96578 3.75 7.09839 3.75H8.59839V1.75H7.09839C6.43535 1.75 5.79946 2.01339 5.33062 2.48223C4.86178 2.95107 4.59839 3.58696 4.59839 4.25V5.255H3.59839L3.40039 7.245H4.59839V11.25Z" fill="white"/></svg>`
  },
  'X': {
    placeholder: "https://www.x.com/user",
    regex: /^https?:\/\/(www\.)?x\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none"><g clip-path="url(#clip0_540_9668)"><mask id="mask0_540_9668" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="1" width="10" height="9"><path d="M0.599609 1.09766H9.39961V9.89766H0.599609V1.09766Z" fill="white"/></mask><g mask="url(#mask0_540_9668)"><path d="M7.52961 1.51172H8.87915L5.93115 4.88966L9.39961 9.48703H6.68418L4.55584 6.69932L2.12327 9.48703H0.772467L3.92538 5.87275L0.599609 1.51235H3.38418L5.3051 4.05995L7.52961 1.51172ZM7.05504 8.67743H7.80304L2.97561 2.2792H2.17355L7.05504 8.67743Z" fill="white"/></g></g><defs><clipPath id="clip0_540_9668"><rect width="9.6" height="9.6" fill="white" transform="translate(0.199219 0.699219)"/></clipPath></defs></svg>`
  },
  'Twitter': {
    placeholder: "https://www.x.com/user",
    regex: /^https?:\/\/(www\.)?x\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none"><g clip-path="url(#clip0_540_9668)"><mask id="mask0_540_9668" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="1" width="10" height="9"><path d="M0.599609 1.09766H9.39961V9.89766H0.599609V1.09766Z" fill="white"/></mask><g mask="url(#mask0_540_9668)"><path d="M7.52961 1.51172H8.87915L5.93115 4.88966L9.39961 9.48703H6.68418L4.55584 6.69932L2.12327 9.48703H0.772467L3.92538 5.87275L0.599609 1.51235H3.38418L5.3051 4.05995L7.52961 1.51172ZM7.05504 8.67743H7.80304L2.97561 2.2792H2.17355L7.05504 8.67743Z" fill="white"/></g></g><defs><clipPath id="clip0_540_9668"><rect width="9.6" height="9.6" fill="white" transform="translate(0.199219 0.699219)"/></clipPath></defs></svg>`
  },
  'LinkedIn': {
    placeholder: "https://www.linkedin.com/user",
    regex: /^https?:\/\/(www\.)?linkedin\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M9.5 2C9.76522 2 10.0196 2.10536 10.2071 2.29289C10.3946 2.48043 10.5 2.73478 10.5 3V10C10.5 10.2652 10.3946 10.5196 10.2071 10.7071C10.0196 10.8946 9.76522 11 9.5 11H2.5C2.23478 11 1.98043 10.8946 1.79289 10.7071C1.60536 10.5196 1.5 10.2652 1.5 10V3C1.5 2.73478 1.60536 2.48043 1.79289 2.29289C1.98043 2.10536 2.23478 2 2.5 2H9.5ZM9.25 9.75V7.1C9.25 6.6677 9.07827 6.2531 8.77258 5.94742C8.4669 5.64173 8.0523 5.47 7.62 5.47C7.195 5.47 6.7 5.73 6.46 6.12V5.565H5.065V9.75H6.46V7.285C6.46 6.9 6.77 6.585 7.155 6.585C7.34065 6.585 7.5187 6.65875 7.64998 6.79003C7.78125 6.9213 7.855 7.09935 7.855 7.285V9.75H9.25ZM3.44 4.78C3.66278 4.78 3.87644 4.6915 4.03397 4.53397C4.1915 4.37644 4.28 4.16278 4.28 3.94C4.28 3.475 3.905 3.095 3.44 3.095C3.21589 3.095 3.00096 3.18403 2.84249 3.34249C2.68403 3.50096 2.595 3.71589 2.595 3.94C2.595 4.405 2.975 4.78 3.44 4.78ZM4.135 9.75V5.565H2.75V9.75H4.135Z" fill="white"/></svg>`
  },
  'Tiktok': {
    placeholder: "https://www.tiktok.com/user",
    regex: /^https?:\/\/(www\.)?tiktok\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><rect width="12" height="12" fill="#FF4265"/><path d="M8.30008 2.91C7.95837 2.51976 7.77003 2.0187 7.77008 1.5H6.22508V7.7C6.21341 8.0356 6.07184 8.35354 5.83023 8.58675C5.58863 8.81996 5.26588 8.9502 4.93008 8.95C4.22008 8.95 3.63008 8.37 3.63008 7.65C3.63008 6.79 4.46008 6.145 5.31508 6.41V4.83C3.59008 4.6 2.08008 5.94 2.08008 7.65C2.08008 9.315 3.46008 10.5 4.92508 10.5C6.49508 10.5 7.77008 9.225 7.77008 7.65V4.505C8.39658 4.95493 9.14876 5.19632 9.92008 5.195V3.65C9.92008 3.65 8.98008 3.695 8.30008 2.91Z" fill="white"/></svg>`
  },
  'Youtube': {
    placeholder: "https://www.youtube.com/user",
    regex: /^https?:\/\/(www\.)?youtube\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.5C6.4275 2.5 6.866 2.511 7.291 2.529L7.793 2.553L8.2735 2.5815L8.7235 2.612L9.1345 2.644C9.58059 2.67795 10.0004 2.86822 10.32 3.1813C10.6396 3.49438 10.8384 3.9102 10.8815 4.3555L10.9015 4.568L10.939 5.023C10.974 5.4945 11 6.0085 11 6.5C11 6.9915 10.974 7.5055 10.939 7.977L10.9015 8.432L10.8815 8.6445C10.8384 9.08988 10.6395 9.50576 10.3198 9.81885C10.0001 10.1319 9.58018 10.3222 9.134 10.356L8.724 10.3875L8.274 10.4185L7.793 10.447L7.291 10.471C6.86091 10.4896 6.43049 10.4993 6 10.5C5.56951 10.4993 5.13909 10.4896 4.709 10.471L4.207 10.447L3.7265 10.4185L3.2765 10.3875L2.8655 10.356C2.41941 10.3221 1.9996 10.1318 1.68002 9.8187C1.36044 9.50562 1.1616 9.0898 1.1185 8.6445L1.0985 8.432L1.061 7.977C1.02292 7.48556 1.00257 6.99291 1 6.5C1 6.0085 1.026 5.4945 1.061 5.023L1.0985 4.568L1.1185 4.3555C1.16158 3.91028 1.36036 3.49453 1.67983 3.18145C1.99931 2.86838 2.419 2.67806 2.865 2.644L3.2755 2.612L3.7255 2.5815L4.2065 2.553L4.7085 2.529C5.13875 2.51036 5.56935 2.50069 6 2.5ZM5 5.2875V7.7125C5 7.9435 5.25 8.0875 5.45 7.9725L7.55 6.76C7.5957 6.7337 7.63365 6.69581 7.66005 6.65017C7.68644 6.60452 7.70033 6.55273 7.70033 6.5C7.70033 6.44727 7.68644 6.39548 7.66005 6.34983C7.63365 6.30419 7.5957 6.2663 7.55 6.24L5.45 5.028C5.40438 5.00166 5.35263 4.9878 5.29995 4.98781C5.24727 4.98782 5.19553 5.00169 5.14992 5.02805C5.10431 5.0544 5.06644 5.0923 5.04012 5.13793C5.0138 5.18357 4.99997 5.23532 5 5.288V5.2875Z" fill="white"/></svg>`
  },
  'YouTube': {
    placeholder: "https://www.youtube.com/user",
    regex: /^https?:\/\/(www\.)?youtube\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.5C6.4275 2.5 6.866 2.511 7.291 2.529L7.793 2.553L8.2735 2.5815L8.7235 2.612L9.1345 2.644C9.58059 2.67795 10.0004 2.86822 10.32 3.1813C10.6396 3.49438 10.8384 3.9102 10.8815 4.3555L10.9015 4.568L10.939 5.023C10.974 5.4945 11 6.0085 11 6.5C11 6.9915 10.974 7.5055 10.939 7.977L10.9015 8.432L10.8815 8.6445C10.8384 9.08988 10.6395 9.50576 10.3198 9.81885C10.0001 10.1319 9.58018 10.3222 9.134 10.356L8.724 10.3875L8.274 10.4185L7.793 10.447L7.291 10.471C6.86091 10.4896 6.43049 10.4993 6 10.5C5.56951 10.4993 5.13909 10.4896 4.709 10.471L4.207 10.447L3.7265 10.4185L3.2765 10.3875L2.8655 10.356C2.41941 10.3221 1.9996 10.1318 1.68002 9.8187C1.36044 9.50562 1.1616 9.0898 1.1185 8.6445L1.0985 8.432L1.061 7.977C1.02292 7.48556 1.00257 6.99291 1 6.5C1 6.0085 1.026 5.4945 1.061 5.023L1.0985 4.568L1.1185 4.3555C1.16158 3.91028 1.36036 3.49453 1.67983 3.18145C1.99931 2.86838 2.419 2.67806 2.865 2.644L3.2755 2.612L3.7255 2.5815L4.2065 2.553L4.7085 2.529C5.13875 2.51036 5.56935 2.50069 6 2.5ZM5 5.2875V7.7125C5 7.9435 5.25 8.0875 5.45 7.9725L7.55 6.76C7.5957 6.7337 7.63365 6.69581 7.66005 6.65017C7.68644 6.60452 7.70033 6.55273 7.70033 6.5C7.70033 6.44727 7.68644 6.39548 7.66005 6.34983C7.63365 6.30419 7.5957 6.2663 7.55 6.24L5.45 5.028C5.40438 5.00166 5.35263 4.9878 5.29995 4.98781C5.24727 4.98782 5.19553 5.00169 5.14992 5.02805C5.10431 5.0544 5.06644 5.0923 5.04012 5.13793C5.0138 5.18357 4.99997 5.23532 5 5.288V5.2875Z" fill="white"/></svg>`
  },
  'Instagram': {
    placeholder: "https://www.instagram.com/user",
    regex: /^https?:\/\/(www\.)?instagram\.com\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M3.9 1.5H8.1C9.7 1.5 11 2.8 11 4.4V8.6C11 9.36913 10.6945 10.1068 10.1506 10.6506C9.60675 11.1945 8.86913 11.5 8.1 11.5H3.9C2.3 11.5 1 10.2 1 8.6V4.4C1 3.63087 1.30553 2.89325 1.84939 2.34939C2.39325 1.80553 3.13087 1.5 3.9 1.5ZM3.8 2.5C3.32261 2.5 2.86477 2.68964 2.52721 3.02721C2.18964 3.36477 2 3.82261 2 4.3V8.7C2 9.695 2.805 10.5 3.8 10.5H8.2C8.67739 10.5 9.13523 10.3104 9.47279 9.97279C9.81036 9.63523 10 9.17739 10 8.7V4.3C10 3.305 9.195 2.5 8.2 2.5H3.8ZM8.625 3.25C8.79076 3.25 8.94973 3.31585 9.06694 3.43306C9.18415 3.55027 9.25 3.70924 9.25 3.875C9.25 4.04076 9.18415 4.19973 9.06694 4.31694C8.94973 4.43415 8.79076 4.5 8.625 4.5C8.45924 4.5 8.30027 4.43415 8.18306 4.31694C8.06585 4.19973 8 4.04076 8 3.875C8 3.70924 8.06585 3.55027 8.18306 3.43306C8.30027 3.31585 8.45924 3.25 8.625 3.25ZM6 4C6.66304 4 7.29893 4.26339 7.76777 4.73223C8.23661 5.20107 8.5 5.83696 8.5 6.5C8.5 7.16304 8.23661 7.79893 7.76777 8.26777C7.29893 8.73661 6.66304 9 6 9C5.33696 9 4.70107 8.73661 4.23223 8.26777C3.76339 7.79893 3.5 7.16304 3.5 6.5C3.5 5.83696 3.76339 5.20107 4.23223 4.73223C4.70107 4.26339 5.33696 4 6 4ZM6 5C5.60218 5 5.22064 5.15804 4.93934 5.43934C4.65804 5.72064 4.5 6.10218 4.5 6.5C4.5 6.89782 4.65804 7.27936 4.93934 7.56066C5.22064 7.84196 5.60218 8 6 8C6.39782 8 6.77936 7.84196 7.06066 7.56066C7.34196 7.27936 7.5 6.89782 7.5 6.5C7.5 6.10218 7.34196 5.72064 7.06066 5.43934C6.77936 5.15804 6.39782 5 6 5Z" fill="white"/></svg>`
  }
};

// Función para obtener la configuración de una red social por nombre
function getSocialNetworkConfig(networkName) {
  // Normalizamos el nombre para manejar variaciones (mayúsculas/minúsculas, espacios)
  const normalizedName = networkName.trim().toLowerCase();
  
  // Buscamos coincidencias flexibles
  for (const [key, config] of Object.entries(socialNetworksConfig)) {
    if (key.toLowerCase() === normalizedName || 
        key.toLowerCase().includes(normalizedName) ||
        normalizedName.includes(key.toLowerCase())) {
      return config;
    }
  }
  
  // Si no encontramos coincidencia, devolvemos configuración por defecto
  return {
    placeholder: "https://www.example.com/user",
    regex: /^https?:\/\/[-a-zA-Z0-9()@:%_+.~#?&//=]*$/,
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M6 1C3.24 1 1 3.24 1 6s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" fill="white"/></svg>`
  };
}

onMounted(async () => {
  try {
    step.value = session.value.step;
    loader_page.value = true;
    getNetworks();
  } catch (error) {
    console.error("Data fetch error:", error);
  }
});

async function getNetworks() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/networks/${session.value.id}`,
      options
    );

    if (response.status == 401) {
      store.dispatch("clearUserSession");
      loader_page.value = false;
    }

    if (response.status == 200) {
      networks_broker.value = JSON.parse(JSON.stringify(response.data.data));
      networks_company.value = JSON.parse(JSON.stringify(response.data.data));
      // filteredProperties.value = response.data.resp;
      loader_page.value = false;
    }
  } catch (error) {
    loader_page.value = false;
    console.error("Error fetching data:", error);
  }
}

async function saveNetworksBroker() {
  loader_page.value = true;
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let params_item = [];
    let hasErrors = false;

    networks_broker.value.forEach((item) => {
      if (item.link_broker && !validateLinkWithRegex(item.link_broker, item.name)) {
        item.error = `Formato incorrecto`;
        loader_page.value = false;
        hasErrors = true
        //throw new Error(`Link inválido: ${item.link_broker}`);
      } else {
        item.error = null;
      }

      let row = {};
      row["id"] = item.id;
      row["link_broker"] = item.link_broker;
      row["user_id"] = session.value.id;
      row["company_id"] = session.value.company_id;

      params_item.push(row);
    });

    if (hasErrors) {
      loader_page.value = false;
      return; // Detiene el guardado si hay errores
    }

    let params = {
      type: "broker",
      step: 3,
      networks: params_item,
    };

    const response = await axios.put(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/update-networks`,
      params,
      options
    );

    if (response.status == 200) {
      if (session.value.step < 3) {
        store.dispatch("updateStep", 3);
        window.location.href = "/properties";
      }

      showToast("success", "Redes sociales guardadas correctamente");
      loader_page.value = false;
    }
  } catch (error) {
    loader_page.value = false;
    console.error("Error fetching data:", error);
  }
}


async function saveLater() {
  loader_page.value = true;
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let params_item = [];

    let params = {
      type: "broker",
      step: 3,
      networks: params_item,
    };

    const response = await axios.put(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/update-networks`,
      params,
      options
    );

    if (response.status === 200) {

      await store.dispatch("updateStep", 3);

      const updatedSession = store.getters.getUserSession;

      // 🔹 Asegura que la sesión en localStorage es correcta
      localStorage.setItem("userSession", JSON.stringify(updatedSession));

      loader_page.value = false;

      // 🔹 Redirige cuando todo está actualizado
      window.location.href = "/properties";
    }
  } catch (error) {
    loader_page.value = false;
    console.error("❌ Error en saveLater:", error);
  }
}


async function showToast(type = null, message = null) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

function validateLinkWithRegex(link, networkName) {
  if (!link) return true; // Si el link está vacío, es válido
  
  const config = getSocialNetworkConfig(networkName);
  return config.regex.test(link);
}

// Esta función ya no es necesaria pero la mantenemos por compatibilidad
/*function getPlaceholder(index) {
  const networks = ['Facebook', 'X', 'LinkedIn', 'Tiktok', 'Youtube', 'Instagram'];
  const networkName = networks[index] || 'Facebook';
  return getSocialNetworkConfig(networkName).placeholder;
}*/
</script>

<style scoped>
.icon-wrapper {
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  background: #FF4265;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
